import _util from '../../utils/';


const airticketAllowanceService = {
	selectAirticketAllowance(data, resolve, reject) {
		_util.request({
			url: '/api/HRSalaryAirticketSubsidy/Get',
			params: data,
			success: resolve,
			error: reject
		})
	},
	deleteAirticketAllowance(data, resolve, reject) {
		_util.request({
			url: '/api/HRSalaryAirticketSubsidy/BatchDelete',
			method: "delete",
			data: data,
			success: resolve,
			error: reject
		})
	},
	updateAirticketAllowance(data, resolve, reject) {
		_util.request({
			url: '/api/HRSalaryAirticketSubsidy/Put',
			method: "put",
			data: data,
			success: resolve,
			error: reject
		})
	},
	createAirticketAllowance(data, resolve, reject) {
		_util.request({
			url: '/api/HRSalaryAirticketSubsidy/Post',
			method: "post",
			data: data,
			success: resolve,
			error: reject
		})
	},
	importAirticketAllowance(data, resolve, reject) {
		_util.request({
			url: '/api/HRSalaryAirticketSubsidy/Import',
			method: "post",
			data: data,
			success: resolve,
			error: reject
		})
	},
	exportAirticketAllowance(data, resolve, reject) {
		_util.request({
			url: '/api/HRSalaryAirticketSubsidy/Export',
			data: data,
			success: resolve,
			error: reject
		})
	},
	downloadAirticketAllowanceTemplate(data, resolve, reject) {
		_util.request({
			url: '/api/HRSalaryAirticketSubsidy/GetImportTemplate',
			data: data,
			success: resolve,
			error: reject
		})
	}
};


export default airticketAllowanceService;




// WEBPACK FOOTER //
// ./src/services/SalaryAllowance/airticket-allowance-service.js